import getValueReduxUtil from 'modules/redux/utils/get-value'

function getNameReduxUtil (instance) {
  return getValueReduxUtil(instance, 'name') || ''
}

export default getNameReduxUtil
